/**
 * ダム諸量グラフ生成
 */
import color from "../../scss/color.scss";
import libCG, { str } from "./MbCommonGraph";

export default {
  name: "lib-mb-dam-graph",
  getSvgGraph,
  getSvgLeftLabel,
  getSvgRightLabel,
  getSvgLegend,
};

// グラフの雨量比率(30%)
const graphRainRatio = 0.3;
// グラフのダム諸量比率(70%)
const graphDamRatio = 0.7;
// グラフ描画領域上余白
const paddingTop = 50;
// グラフ描画領域下余白
const paddingBottom = 150;
// ラベル描画領域左余白
const paddingLeft = 50;
// ラベル描画領域右余白
const paddingRight = 50;
// グラフ間余白
const paddingMiddle = 80;
// 雨量ラベル分割数
const rainDivY = 4;
// ダム諸量ラベル分割数
const damDivY = 8;
// ラベル表示間隔
const spaceY = 2;
// 雨量ラベル桁数（小数点以下）
const rainLabelDisit = 0;
// ダム諸量ラベル桁数（小数点以下）
const damLabelDisit = 1;

// 凡例サイズ
const legendWidth = 1110;
const legendHeightRain = 240;
const legendHeightDam = 550;
const legendPadding = 10;
// 実際の表示幅
const legendViewWidth = 140;

// 「緊急放流(異常洪水時防災操作)判断水位」文字列
const strDamStorPrvs = "緊急放流(異常洪水時防災操作)判断水位";
// 「貯水率(利水容量)」文字列
const strDamStorIrr = "貯水率(利水容量)";
// 「貯水率(治水容量)」文字列
const strDamStorFlood = "貯水率(治水容量)";
// 貯水率単位
const strDamStorUnit = "％";
// 「全流入量」文字列
const strDamAllSink = "全流入量";
// 「全放流量」文字列
const strDamAllDisch = "全放流量";
// 「洪水貯留操作開始流量」文字列
const strDamAllFldctl = "洪水貯留操作開始流量";

// 見出し文字サイズ
const baseRainTitleSize = 68;
const baseRainTitleWeight = 500;
const baseStorTitleSize = 68;
const baseStorTitleWeight = 500;
const baseFloodTitleSize = 68;
const baseFloodTitleWeight = 500;

// グラフのスタイル
const styleGraph = `<![CDATA[
  .kwg-rain-normal {
    fill: ${color.rainRainNormal};
    stroke: ${color.rainRainNormal};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-total-normal {
    fill: ${color.rainTotalNormal};
    stroke: ${color.rainTotalNormal};
    stroke-width: 7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-stor-level-normal {
    fill: ${color.tmDamdschNormal};
    stroke: ${color.tmDamdschNormal};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-stor-level-proviso {
    fill: ${color.tmDamdschPrevop};
    stroke: ${color.tmDamdschPrevop};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-stor-level-proviso-border {
    fill: null;
    stroke: ${color.tmDamdschPrevop};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-all-sink-normal {
    fill: ${color.damAllSinkNormal};
    stroke: ${color.damAllSinkNormal};
    stroke-width: 7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-all-sink-fldctl {
    fill: ${color.damAllSinkRiserving};
    stroke: ${color.damAllSinkRiserving};
    stroke-width: 7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-all-sink-fldctl-border {
    fill: null;
    stroke: ${color.damAllSinkRiserving};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-all-disch-normal {
    fill: ${color.damAllDischNormal};
    stroke: ${color.damAllDischNormal};
    stroke-width: 9;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
]]>`;
// 左ラベルのスタイル
const styleLeftLabel = `<![CDATA[
  .kwg-rain-label {
    fill: ${color.rainRainNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-rain-title {
    fill: ${color.rainRainNormal};
    font-weight: TITLERAINWEIGHT;
    font-size: TITLERAINSIZE;
  }
  .kwg-stor-label {
    fill: ${color.tmDamdschNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-stor-title {
    fill: ${color.tmDamdschNormal};
    font-weight: TITLESTORWEIGHT;
    font-size: TITLESTORSIZE;
  }
  .kwg-stor-level-proviso-marker {
    fill: ${color.tmDamdschPrevop};
    stroke: ${color.tmDamdschPrevop};
    stroke-width: 1;
  }
]]>`;
// 右ラベルのスタイル
const styleRightLabel = `<![CDATA[
  .kwg-total-label {
    fill: ${color.rainTotalNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-total-title {
    fill: ${color.rainTotalNormal};
    font-weight: TITLERAINWEIGHT;
    font-size: TITLERAINSIZE;
  }
  .kwg-all-label {
    fill: ${color.damAllSinkNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-all-title-sink {
    fill: ${color.damAllSinkNormal};
    font-weight: TITLEFLOODWEIGHT;
    font-size: TITLEFLOODSIZE;
  }
  .kwg-all-title-disch {
    fill: ${color.damAllDischNormal};
    font-weight: TITLEFLOODWEIGHT;
    font-size: TITLEFLOODSIZE;
  }
  .kwg-all-fldctl-marker {
    fill: ${color.damAllSinkRiserving};
    stroke: ${color.damAllSinkRiserving};
    stroke-width: 1;
  }
]]>`;
// 凡例のスタイル
const styleLegend = `<![CDATA[
  .kwg-legend-rect {
    fill: white;
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-line {
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-label {
    fill: black;
    font-weight: 500;
    font-size: 53px;
  }
  .kwg-legend-label-unit {
    fill: black;
    font-weight: 500;
    font-size: 36px;
  }
]]>`;

/**
 * SVGグラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *      irr: 貯水率(利水容量)
 *      flood: 貯水率(治水容量)
 *      sink: 全流入量
 *      disch: 全放流量
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      stor: 貯水位
 *        max: 貯水位最大値
 *        prvs: 異常洪水時防災操作開始水位
 *        min: 貯水位最小値
 *        title: 貯水位ラベル
 *        unit: 貯水位単位
 *      all: 全流入量・全放流量
 *        max: 全流入量・全放流量最大値
 *        fldctl: 洪水貯留操作開始流量
 *        min: 全流入量・全放流量最小値
 *        titleSink: 全流入量ラベル
 *        titleDisch: 全放流量ラベル
 *        unit: 全流入量・全放流量単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showDam: ダム諸量グラフ表示（true=表示, false=非表示）
 * @return SVGグラフ
 */
function getSvgGraph(obsInfo, viewProp) {
  // svgタグ生成
  let svgGraph = libCG.makeGraphSvgTag(
    viewProp.width,
    viewProp.height,
    viewProp.isExp
  );
  // gタグ追加
  addGGraph(svgGraph, obsInfo, viewProp, false, 0);

  return svgGraph.outerHTML;
}

/**
 * グラフグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} isSvg 画像提供モード
 * @param {*} offsetY 余白の高さ
 */
function addGGraph(parent, obsInfo, viewProp, isSvg, offsetY) {
  // gタグ追加
  let g = libCG.addGraphGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleGraph);
  // グラフ表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeGraphWidth(isSvg ? false : viewProp.isExp);
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // 時刻ラベル追加
  libCG.addGraphXAxisLabelTag(
    g,
    x,
    y + h,
    w,
    obsInfo.value,
    viewProp.isExp,
    viewProp.isHour
  );

  // 雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showDam) {
      h = h * graphRainRatio - paddingMiddle;
    }
    // 雨量フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      rainDivY
    );
    // 雨量ツールチップ追加
    addRainGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 雨量グラフ追加
    addRainGraphBar(g, x, y, w, h, obsInfo, viewProp);
    // 累加雨量グラフ追加
    addTotalGraphLine(g, x, y, w, h, obsInfo, viewProp);
  }

  // ダム諸量グラフ
  if (viewProp.showDam) {
    // ダム諸量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showRain) {
      y = y + h * graphRainRatio + paddingMiddle;
      h = h * graphDamRatio - paddingMiddle;
    }
    // ダム諸量フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      damDivY
    );
    // ダム諸量ツールチップ追加
    addDamGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 貯水位グラフ追加
    addDamStorGraphBar(g, x, y, w, h, obsInfo, viewProp);
    // 全放流量グラフ追加
    addDamAllDischGraphLine(g, x, y, w, h, obsInfo, viewProp);
    // 全流入量グラフ追加
    addDamAllSinkGraphLine(g, x, y, w, h, obsInfo, viewProp);
    // 貯水位ボーダーライン追加
    addDamStorGraphBorder(g, x, y, w, h, obsInfo);
    // 全流入量・全放流量ボーダーライン追加
    addDamAllGraphBorder(g, x, y, w, h, obsInfo);
  }

  return g;
}

/**
 * ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addRainGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeRainTip(obsInfo, data, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 雨量棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addRainGraphBar(parent, left, top, width, height, obsInfo, viewProp) {
  let cls = "kwg-rain-normal";
  let max = obsInfo.spec.rain.max;
  let min = obsInfo.spec.rain.min;

  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let y;
  let tag;
  let current;

  for (let index = 0; index < obsInfo.value.length; index++) {
    current = obsInfo.value[index];
    x = x - xs;
    if (
      current != null &&
      current.rain != null &&
      current.rain <= max &&
      current.rain > min
    ) {
      y = ys * current.rain;
      tag = libCG.makeBarGraphSvgTag(
        x - (xs / 2 - 1) + 1, // 中央表示のため幅の半分だけ左にずらす
        top + 1,
        xs - 2,
        y,
        cls,
        makeRainTip(obsInfo, current, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 累加雨量線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addTotalGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-total-normal";
  let max = obsInfo.spec.total.max;
  let min = obsInfo.spec.total.min;

  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.total == null ||
      current.total > max ||
      current.total <= min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.total == null ||
      next.total > max ||
      next.total <= min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = top + ys * (current.total - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = top + ys * (next.total - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeRainTip(obsInfo, next, false, true)
      );
      parent.appendChild(tag);
    }

    if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        2,
        cls,
        makeRainTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  if (prev == null) {
    current = obsInfo.value[obsInfo.value.length - 1];
    if (
      current != null &&
      current.total != null &&
      current.total <= max &&
      current.total > min
    ) {
      x1 = x - xs - 1;
      y1 = top + ys * (current.total - min);
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        2,
        cls,
        makeRainTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 雨量ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} showRain 雨量表示
 * @param {*} showTotal 累加雨量表示
 */
function makeRainTip(obsInfo, data, showRain, showTotal) {
  let spec = obsInfo.spec;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 雨量
  if (showRain) {
    tip = tip + str.CRLF + spec.rain.title + str.Sept;
    if (data.rain != null) {
      tip = tip + data.rain + spec.rain.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 累加雨量
  if (showTotal) {
    tip = tip + str.CRLF + spec.total.title + str.Sept;
    if (data.total != null) {
      tip = tip + data.total + spec.rain.unit;
    } else {
      tip = tip + str.None;
    }
  }

  return tip;
}

/**
 * ダム諸量ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addDamGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeDamTip(obsInfo, data, true, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 貯水位棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addDamStorGraphBar(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let max = obsInfo.spec.stor.max;
  let min = obsInfo.spec.stor.min;
  let prvs = obsInfo.spec.stor.prvs;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let ys = height / (max - min);
  let y, h, t;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    t = max;
    if (
      data == null ||
      data.level == null ||
      data.level > max ||
      data.level < min
    ) {
      continue;
    }
    if (prvs != null && prvs > min && data.level > prvs) {
      y = bottom - ys * (Math.min(data.level, t) - min);
      h = bottom - ys * (prvs - min) - y;
      t = prvs;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-stor-level-proviso",
        makeDamTip(obsInfo, data, true, true, true)
      );
      parent.appendChild(tag);
    }
    y = bottom - ys * (Math.min(data.level, t) - min);
    h = bottom - y - 1;
    tag = libCG.makeBarGraphSvgTag(
      x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
      y,
      w,
      h,
      "kwg-stor-level-normal",
      makeDamTip(obsInfo, data, true, true, true)
    );
    parent.appendChild(tag);
  }
}

/**
 * 全放流量線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addDamAllDischGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-all-disch-normal";
  let spec = obsInfo.spec.all;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.disch == null ||
      current.disch > max ||
      current.disch < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.disch == null ||
      next.disch > max ||
      next.disch < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.disch - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.disch - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeDamTip(obsInfo, next, false, false, true)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeDamTip(obsInfo, current, false, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeDamTip(obsInfo, current, false, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.disch != null &&
    current.disch <= max &&
    current.disch >= min
  ) {
    x1 = x - xs - 1;
    y1 = bottom - ys * (current.disch - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeDamTip(obsInfo, current, false, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeDamTip(obsInfo, current, false, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 全流入量線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addDamAllSinkGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-all-sink-normal";
  let spec = obsInfo.spec.all;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.sink == null ||
      current.sink > max ||
      current.sink < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.sink == null ||
      next.sink > max ||
      next.sink < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.sink - min);

    if (spec.fldctl != null && current.sink >= spec.fldctl) {
      cls = "kwg-all-sink-fldctl";
    } else {
      cls = "kwg-all-sink-normal";
    }

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.sink - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeDamTip(obsInfo, next, false, true, false)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeDamTip(obsInfo, current, false, true, false)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeDamTip(obsInfo, current, false, true, false)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.sink != null &&
    current.sink <= max &&
    current.sink >= min
  ) {
    if (spec.fldctl != null && current.sink >= spec.fldctl) {
      cls = "kwg-all-sink-fldctl";
    } else {
      cls = "kwg-all-sink-normal";
    }

    x1 = x - xs - 1;
    y1 = bottom - ys * (current.sink - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeDamTip(obsInfo, current, false, true, false)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeDamTip(obsInfo, current, false, true, false)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 貯水位ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addDamStorGraphBorder(parent, left, top, width, height, obsInfo) {
  let spec = obsInfo.spec.stor;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.prvs != null && spec.prvs <= max && spec.prvs >= min) {
    y = bottom - ys * (spec.prvs - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-stor-level-proviso-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * 全流入量・全放流量ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addDamAllGraphBorder(parent, left, top, width, height, obsInfo) {
  let spec = obsInfo.spec.all;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.fldctl != null && spec.fldctl <= max && spec.fldctl >= min) {
    y = bottom - ys * (spec.fldctl - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-all-sink-fldctl-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * ダム諸量ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} showStor 貯水位表示
 * @param {*} showSink 全流入量表示
 * @param {*} showDisch 全放流量表示
 */
function makeDamTip(obsInfo, data, showStor, showSink, showDisch) {
  let spec = obsInfo.spec;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 貯水位
  if (showStor) {
    tip = tip + str.CRLF + spec.stor.title + str.Sept;
    if (data.level != null) {
      tip = tip + data.level + spec.stor.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 貯水率(利水容量)
  if (showStor && data.irr != null) {
    tip = tip + str.CRLF + strDamStorIrr + str.Sept + data.irr + strDamStorUnit;
  }
  // 貯水率(治水容量)
  if (showStor && data.flood != null) {
    tip =
      tip + str.CRLF + strDamStorFlood + str.Sept + data.flood + strDamStorUnit;
  }
  // 全流入量
  if (showSink) {
    tip = tip + str.CRLF + strDamAllSink + str.Sept;
    if (data.sink != null) {
      tip = tip + data.sink + spec.all.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 全放流量
  if (showDisch) {
    tip = tip + str.CRLF + strDamAllDisch + str.Sept;
    if (data.disch != null) {
      tip = tip + data.disch + spec.all.unit;
    } else {
      tip = tip + str.None;
    }
  }

  return tip;
}

/********** **********/

/**
 * SVG左軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *      irr: 貯水率(利水容量)
 *      flood: 貯水率(治水容量)
 *      sink: 全流入量
 *      disch: 全放流量
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      stor: 貯水位
 *        max: 貯水位最大値
 *        prvs: 異常洪水時防災操作開始水位
 *        min: 貯水位最小値
 *        title: 貯水位ラベル
 *        unit: 貯水位単位
 *      all: 全流入量・全放流量
 *        max: 全流入量・全放流量最大値
 *        fldctl: 洪水貯留操作開始流量
 *        min: 全流入量・全放流量最小値
 *        titleSink: 全流入量ラベル
 *        titleDisch: 全放流量ラベル
 *        unit: 全流入量・全放流量単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showDam: ダム諸量グラフ表示（true=表示, false=非表示）
 * @return SVG左ラベル
 */
function getSvgLeftLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgLeftLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGLeftLabel(svgLeftLabel, obsInfo, viewProp, 0);

  return svgLeftLabel.outerHTML;
}

/**
 * 左ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGLeftLabel(parent, obsInfo, viewProp, offsetY) {
  let spec;
  let tip;
  // ダム諸量左ラベル表示範囲
  let x = paddingLeft;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingLeft;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addLeftLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // styleタグ追加
  let style = String(styleLeftLabel);
  const sizeRain = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseRainTitleSize,
    baseRainTitleWeight
  );
  const sizeStor = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseStorTitleSize,
    baseStorTitleWeight
  );
  style = style.replace(/TITLERAINWEIGHT/g, sizeRain.weight);
  style = style.replace(/TITLERAINSIZE/g, sizeRain.size + "px");
  style = style.replace(/TITLESTORWEIGHT/g, sizeStor.weight);
  style = style.replace(/TITLESTORSIZE/g, sizeStor.size + "px");
  libCG.addStyleTag(g, style);
  // 雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showDam) {
      h = h * graphRainRatio - paddingMiddle;
    }
    spec = obsInfo.spec.rain;
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.min,
      spec.max,
      rainLabelDisit,
      rainDivY,
      spaceY,
      "kwg-rain-label",
      spec.unit
    );
    // ラベルタグ追加
    libCG.addLeftLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-rain-title"
    );
  }
  // 貯水位グラフ
  if (viewProp.showDam) {
    // 貯水位グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showRain) {
      y = y + h * graphRainRatio + paddingMiddle;
      h = h * graphDamRatio - paddingMiddle;
    }
    spec = obsInfo.spec.stor;
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.max,
      spec.min,
      damLabelDisit,
      damDivY,
      spaceY,
      "kwg-stor-label",
      spec.unit
    );

    // ラベルタグ追加
    libCG.addLeftLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-stor-title"
    );
    // 異常洪水時防災操作開始水位ボーダーマーカータグ追加
    if (spec.prvs != null && spec.prvs <= spec.max && spec.prvs >= spec.min) {
      tip = strDamStorPrvs + str.Sept + spec.prvs + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.prvs,
        tip,
        "kwg-stor-level-proviso-marker"
      );
    }
  }

  return g;
}

/********** **********/

/**
 * SVG右軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *      irr: 貯水率(利水容量)
 *      flood: 貯水率(治水容量)
 *      sink: 全流入量
 *      disch: 全放流量
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      stor: 貯水位
 *        max: 貯水位最大値
 *        prvs: 異常洪水時防災操作開始水位
 *        min: 貯水位最小値
 *        title: 貯水位ラベル
 *        unit: 貯水位単位
 *      all: 全流入量・全放流量
 *        max: 全流入量・全放流量最大値
 *        fldctl: 洪水貯留操作開始流量
 *        min: 全流入量・全放流量最小値
 *        titleSink: 全流入量ラベル
 *        titleDisch: 全放流量ラベル
 *        unit: 全流入量・全放流量単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showDam: ダム諸量グラフ表示（true=表示, false=非表示）
 * @return SVG右ラベル
 */
function getSvgRightLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgRightLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGRightLabel(svgRightLabel, obsInfo, viewProp, 0);

  return svgRightLabel.outerHTML;
}

/**
 * 右ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGRightLabel(parent, obsInfo, viewProp, offsetY) {
  let spec;
  let tip;
  // 水位右ラベル表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingRight;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addRightLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // styleタグ追加
  let style = String(styleRightLabel);
  const sizeRain = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseRainTitleSize,
    baseRainTitleWeight
  );
  const sizeDam = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseFloodTitleSize,
    baseFloodTitleWeight
  );
  style = style.replace(/TITLERAINWEIGHT/g, sizeRain.weight);
  style = style.replace(/TITLERAINSIZE/g, sizeRain.size + "px");
  style = style.replace(/TITLEFLOODWEIGHT/g, sizeDam.weight);
  style = style.replace(/TITLEFLOODSIZE/g, sizeDam.size + "px");
  libCG.addStyleTag(g, style);
  // 累加雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    h = h * graphRainRatio - paddingMiddle;
    spec = obsInfo.spec.total;
    // 目盛タグ追加
    libCG.addRightLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.min,
      spec.max,
      rainLabelDisit,
      rainDivY,
      spaceY,
      "kwg-total-label",
      spec.unit
    );
    // ラベルタグ追加
    libCG.addRightLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-total-title"
    );
  }
  // 全流入量・全放流量グラフ
  if (viewProp.showDam) {
    // 全流入量・全放流量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showRain) {
      y = y + h * graphRainRatio + paddingMiddle;
      h = h * graphDamRatio - paddingMiddle;
    }
    spec = obsInfo.spec.all;
    // 目盛タグ追加
    libCG.addRightLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.max,
      spec.min,
      damLabelDisit,
      damDivY,
      spaceY,
      "kwg-all-label",
      spec.unit
    );
    // ラベルタグ追加
    const titleList = [
      { nm: spec.titleSink + str.Div, cls: "kwg-all-title-sink" },
      { nm: spec.titleDisch, cls: "kwg-all-title-disch" },
    ];
    libCG.addRightLabelYAxisTitleTagMulti(g, x, y, w, h, titleList);
    // 洪水貯留操作開始流量ボーダーマーカータグ追加
    if (
      spec.fldctl != null &&
      spec.fldctl <= spec.max &&
      spec.fldctl >= spec.min
    ) {
      tip = strDamAllFldctl + str.Sept + spec.fldctl + spec.unit;
      libCG.addRightLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.fldctl,
        tip,
        "kwg-all-fldctl-marker"
      );
    }
  }

  return g;
}

/********** **********/

/**
 * SVG凡例取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *      irr: 貯水率(利水容量)
 *      flood: 貯水率(治水容量)
 *      sink: 全流入量
 *      disch: 全放流量
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      stor: 貯水位
 *        max: 貯水位最大値
 *        prvs: 異常洪水時防災操作開始水位
 *        min: 貯水位最小値
 *        title: 貯水位ラベル
 *        unit: 貯水位単位
 *      all: 全流入量・全放流量
 *        max: 全流入量・全放流量最大値
 *        fldctl: 洪水貯留操作開始流量
 *        min: 全流入量・全放流量最小値
 *        titleSink: 全流入量ラベル
 *        titleDisch: 全放流量ラベル
 *        unit: 全流入量・全放流量単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showDam: ダム諸量グラフ表示（true=表示, false=非表示）
 * @return SVG凡例
 */
function getSvgLegend(obsInfo, viewProp) {
  // svgタグ生成
  let svgLegend = libCG.makeLegendSvgTag(
    legendWidth + legendPadding,
    legendHeightRain + legendHeightDam + legendPadding,
    legendViewWidth
  );
  // gタグ追加
  addGLegend(svgLegend, obsInfo, viewProp);

  return svgLegend.outerHTML;
}

/**
 * 凡例グループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addGLegend(parent, obsInfo, viewProp) {
  let tag;
  let spec = obsInfo.spec;
  let w = legendWidth;
  let h = legendHeightRain;
  let x = 0;
  // eslint-disable-next-line
  let y;
  // gタグ追加
  let g = libCG.addLegendGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleLegend);

  // 雨量凡例
  if (viewProp.showRain) {
    // 枠
    tag = libCG.makeLegendFrame(5, 5, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    y = 75;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.rain.title,
      "kwg-legend-label",
      spec.rain.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendBarGraph(
      g,
      x,
      y,
      "kwg-rain-normal",
      spec.rain.title,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-total-normal",
      spec.total.title,
      "kwg-legend-label"
    );
  }
  // ダム諸量凡例
  if (viewProp.showDam) {
    w = legendWidth;
    h = legendHeightDam;
    y = viewProp.showRain ? legendHeightRain + 5 : 5;
    // 枠
    tag = libCG.makeLegendFrame(5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 仕切線
    tag = libCG.makeLegendLine(5, y + 240, w, y + 240, "kwg-legend-line");
    g.appendChild(tag);
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.stor.title,
      "kwg-legend-label",
      spec.stor.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendBarGraph(
      g,
      x,
      y,
      "kwg-stor-level-normal",
      spec.stor.title,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-stor-level-proviso-border",
      strDamStorPrvs,
      "kwg-legend-label"
    );
    y = y + 30;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.all.titleSink + str.Div + spec.all.titleDisch,
      "kwg-legend-label",
      spec.all.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-all-sink-normal",
      strDamAllSink,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-all-disch-normal",
      strDamAllDisch,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-all-sink-fldctl-border",
      strDamAllFldctl,
      "kwg-legend-label"
    );
  }

  return g;
}
